import { useCallback, useState } from "react";

export interface IMoveDrawer {
  isOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  toggleMenu: () => void;
  showCheckboxes: boolean;
}

export function useMoveDrawerState(): IMoveDrawer {
  const [isOpen, setOpen] = useState(false);
  const openMenu = useCallback(() => setOpen(true), []);
  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((val) => !val), []);

  return {
    isOpen,
    openMenu,
    closeMenu,
    toggleMenu,
    showCheckboxes: isOpen, // TODO: fix this it's very flawed at the moment, you literally can't use this feature on mobile
  };
}
